// extracted by mini-css-extract-plugin
export default {"modal":"PaymentModal__modal___CKjEp"};